import { Tooltip } from 'antd';
import { isValidMessage } from '@/scripts/utils/isValidMessage';
import type { ChatParams } from '@/contexts/chat/scripts/hooks/useChats/types';
import { type Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import classes from './index.module.scss';
import MentionIcon from './images/mention.svg?react';
import ToolsIcon from './images/tools.svg?react';
import FormatIcon from './images/format.svg?react';
import MoreIcon from './images/more.svg?react';
import SendIcon from './images/send.svg?react';
import ZoomIcon from './images/zoom.svg?react';
import Emoji from './components/emoji';
import Pictures from './components/pictures';
import ExpireTime from './components/expire-time';
import FilesUpload from './components/files-upload';
//import DownIcon from './images/down.svg?react';

export interface ChatInputProps {
  className?: ClassNames;
  chat: Chat;
  value: string;
  onSend: () => void;
  onEmojiClick?: (emoji: string) => void;
  onPicturesSelect: () => void;
  onFilesSelect: () => void;
  updateChats: (chats: ChatParams[]) => Promise<void>;
}

export default function ChatInputExtend({
  className,
  chat,
  value,
  onSend,
  onEmojiClick,
  onPicturesSelect,
  onFilesSelect,
  updateChats,
}: ChatInputProps) {
  return (
    <div
      className={cls(classes.chatInputExtends, className)}
      onClick={(e) => e.stopPropagation()}
    >
      <ExpireTime chat={chat} updateChats={updateChats} />
      <Emoji onEmojiClick={onEmojiClick} />
      <MentionIcon></MentionIcon>
      <Pictures onSelect={onPicturesSelect} />
      <FilesUpload selectFilesClick={onFilesSelect} />
      <ToolsIcon></ToolsIcon>
      <FormatIcon></FormatIcon>
      <MoreIcon></MoreIcon>
      <ZoomIcon></ZoomIcon>
      <div className={classes.divider}></div>
      <Tooltip title="Enter">
        <div
          className={cls(classes.send, isValidMessage(value) && classes.sendActive)}
          onClick={onSend}
        >
          <SendIcon />
        </div>
      </Tooltip>
      {/* <DownIcon></DownIcon> */}
    </div>
  );
}
